import 'reset.css';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vueDebounce from 'vue-debounce'
import JsonCSV from 'vue-json-csv';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueScrollTo from 'vue-scrollto';

Array.prototype.shuffle = function() {

  for (let i = this.length - 1; i >= 0; i--) {

    const randomIndex = Math.floor(Math.random() * (i + 1));
    const itemAtIndex = this[randomIndex];

    this[randomIndex] = this[i];
    this[i] = itemAtIndex;
  }
  return this;
}


Vue.use(BootstrapVue);
Vue.use(vueDebounce);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 1000,
  easing: "easeInOutExpo",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.component('DownloadCsv', JsonCSV);

Vue.config.productionTip = false

// Vue.prototype.$http = axios.create({
//   baseURL: ""
// });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
